import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'access-llm',
  name: 'Access LLM',
  category: 'ai',
  description: 'Access Group LiteLLM proxy for AI models - centralised AI gateway with cost tracking (no credentials required)',
  icon: 'Brain',
  iconType: 'lucide',
  color: 'purple',
  version: '1.0.0',

  // Mark as sub-node - only used with AI Agent
  isSubNode: true,
  subNodeConfig: {
    category: 'chatModel',
    requiredFor: ['aiAgent'],
    multipleAllowed: false // Only one chat model per AI Agent
  },

  group: ['ai'],

  defaults: {
    name: 'Access LLM',
    color: '#8b5cf6'
  },

  subtitle: '={{ $parameter.model }}',

  // No credentials required - uses platform system credential (litellm-system)
  credentials: [],

  requestDefaults: {
    baseURL: 'https://api.dev.eu.ai.access-evo.com/dev/litellm/api',
    headers: {
      'Content-Type': 'application/json',
      'tag-origindivision': 'evo',
      'tag-originproduct': 'evo-workflow-automation'
    }
  },

  // Sub-nodes don't have traditional inputs/outputs
  // They are connected via special anchors
  inputs: [],
  outputs: [],

  // Anchors define the visual connection points
  anchors: {
    input: [
      {
        type: 'subNode',
        subNodeCategory: 'chatModel',
        label: 'Chat Model',
        multiple: false
      }
    ]
  },

  tags: ['ai', 'llm', 'chat', 'access', 'litellm', 'text-generation', 'gpt', 'claude', 'central']
};

export default definition;
